"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const Tenant = __importStar(require("../../../../../../tenant"));
const User = __importStar(require("../../../../../../user"));
const openapi_1 = require("../../../../../openapi");
const Schema = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Admin.Tenant.Spec';
const Role = User.GlobalUserRole.enums;
/** `onlyAdmins`: SystemAdmin and Admin. The guard answers with the v1 `{ message }` body. */
const withOnlyAdmins = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin);
const tenantId = platform_1.HttpApiSchema.param('tenantId', Tenant.Id);
const malformedJson = "Malformed JSON gets Express's default HTML 400, not the v2 error body.";
const TenantResponse = openapi_1.Response.Success(Tenant.Tenant).annotations({
    description: 'The tenant',
});
const TenantListResponse = openapi_1.Response.Success(Schema.TenantList).annotations({
    description: Schema.tenantListDescription,
});
const listTenants = platform_1.HttpApiEndpoint.get('listTenants') `/tenant`
    .addSuccess(TenantListResponse)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'List Tenants')
    .annotate(platform_1.OpenApi.Description, Schema.tenantListDescription)
    .pipe(withOnlyAdmins, openapi_1.Error.withV1StandardErrors);
const getTenant = platform_1.HttpApiEndpoint.get('getTenant') `/tenant/${tenantId}`
    .addSuccess(TenantResponse)
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.NotFound)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Get Tenant')
    .annotate(platform_1.OpenApi.Description, 'Returns one tenant by id. An id that is not a non-empty string is 400. An unknown id is 404.')
    .pipe(withOnlyAdmins, openapi_1.Error.withV1StandardErrors);
const createTenant = platform_1.HttpApiEndpoint.post('createTenant') `/tenant/${tenantId}`
    .setPayload(Schema.CreateTenantPayload)
    .addSuccess(TenantResponse)
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Create Tenant')
    .annotate(platform_1.OpenApi.Description, 'Creates a tenant and returns it. The path segment is named tenantId so it is the same OpenAPI path as GET and DELETE; the value is the parent tenant id the new tenant is attached to. id, createdAt and updatedAt are omitted only on this tenant and assigned by the server. subTenants is required. Each nested tenant still has its own id, createdAt and updatedAt, which the server stores as sent. A body that parses but fails validation is the v2 400, as is an invalid path. ' +
    `${malformedJson} A missing parent is 500.`)
    .pipe(withOnlyAdmins, openapi_1.Error.withV1StandardErrors);
const updateTenant = platform_1.HttpApiEndpoint.put('updateTenant') `/tenant`
    .setPayload(Tenant.Tenant)
    .addSuccess(TenantResponse)
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Update Tenant')
    .annotate(platform_1.OpenApi.Description, 'Replaces a tenant. The body is a full tenant, including id, createdAt and updatedAt. subTenants from the body replaces the whole subtree, so subTenants: [] drops every child and still succeeds. A body that parses but fails validation is the v2 400. ' +
    `${malformedJson} An unknown tenant is 500. The root is 500 as well, because the update only looks at the root's children.`)
    .pipe(withOnlyAdmins, openapi_1.Error.withV1StandardErrors);
const deleteTenant = platform_1.HttpApiEndpoint.del('deleteTenant') `/tenant/${tenantId}`
    .addSuccess(openapi_1.Response.noContent())
    .addError(openapi_1.Error.Validation)
    .addError(openapi_1.Error.Internal)
    .annotate(platform_1.OpenApi.Title, 'Delete Tenant')
    .annotate(platform_1.OpenApi.Description, 'Deletes a tenant. Success is 204 with no body. An invalid id is 400. ' +
    'The root tenant is 500 ("Root tenant cannot be deleted."). ' +
    'Any other id found in the tenant tree is also 500 ("Tenant with existent subtenants cannot be deleted."), including a tenant with no children. ' +
    'An id that is not in the tree leaves the tree unchanged and answers 204.')
    .pipe(withOnlyAdmins, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v2.admin.tenant')
    .add(listTenants)
    .add(getTenant)
    .add(createTenant)
    .add(updateTenant)
    .add(deleteTenant)
    .prefix('/admin')
    .annotate(platform_1.OpenApi.Title, 'Tenant Management')
    .annotate(platform_1.OpenApi.Description, 'Admin endpoints for listing, creating, updating and deleting tenants.')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map